<template>
  <div>
    <div
      v-if="anyUserOrganizationsAvailable"
      :class="appUserRole !== 'worker' ? 'approved-app-user-listing' : ''"
    >
      <v-row v-if="!workerCheck && companyVisibility">
        <v-col
          cols="10"
          class="pb-0 pt-0"
        >
          <v-select
            v-model="selectedCompany"
            light
            color="#37474F"
            flat
            dense
            :items="appUserCompanies"
            item-text="name"
            item-value="id"
            label="Company"
            outlined
            background-color="transparent"
            class="small-select"
            @change="changeCompany"
          />
        </v-col>
        <v-col
          cols="2"
          class="d-flex pt-0"
        >
          <v-btn
            fab
            small
            outlined
            color="#37474F"
            elevation="0"
            @click="clearAllFilters"
          >
            <v-icon size="18">
              mdi-filter-off
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-if="!workerCheck"
        class="py-0"
      >
        <v-col class="py-0 pr-0">
          <v-text-field
            v-model="searchQuery"
            placeholder="Search..."
            outlined
            hide-details
            color="#37474F"
            light
            class="search-bar"
            dense
            flat
          />
        </v-col>
        <v-col
          cols="2"
          class="d-flex pt-0"
        >
          <v-btn
            fab
            small
            outlined
            color="#37474F"
            elevation="0"
            @click="searchAppUser"
          >
            <v-icon size="20">
              mdi-magnify
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <br>
      <div v-if="!workerCheck">
        <div v-if="anyAppUsersListAvailable">
          <v-card
            v-for="(item, index) in acceptedAppUsersList"
            :key="index"
            class="mb-4 user-card"
            elevation="0"
            :class="{ 'inactive-border': !item.active, 'active-border': item.active }"
          >
            <div class="d-flex align-center bg-light pa-4">
              <v-avatar
                color="blue-grey lighten-4"
                size="48"
                class="mr-4"
              >
                <span class="blue-grey--text text--darken-3 font-weight-bold">
                  {{ item.first_name[0] }}{{ item.last_name[0] }}
                </span>
              </v-avatar>

              <div class="flex-grow-1">
                <div class=" font-weight-bold grey--text text--darken-2 mb-0">
                  {{ item.first_name }} {{ item.last_name }}
                </div>
                <div class="text-caption d-flex align-center grey--text text--darken-1">
                  <v-icon
                    x-small
                    class="mr-1"
                    light
                  >
                    mdi-office-building
                  </v-icon>
                  {{ item.company.name }}
                </div>
              </div>

              <div class="d-flex flex-column align-end">
                <v-btn
                  icon
                  color="gray"
                  light
                  @click="openAppUserDetails(item)"
                >
                  <v-icon>mdi-chevron-right-circle-outline</v-icon>
                </v-btn>
              </div>
            </div>

            <v-divider v-if="item.id !== selectedOrganization.id" color="gray" class="mx-4" />

            <div class="px-4 py-1 d-flex align-center justify-space-between bg-light">
              <div v-if="item.app_user_organization_id !== selectedOrganization.app_user_organization_id" class="d-flex align-center">
                <v-switch
                  v-model="item.active"
                  dense
                  hide-details
                  color="success"
                  class="mt-0 pt-0 mr-2"
                  @change="toggleUserStatus(item)"
                />
                <span
                  class="text-overline font-weight-bold"
                  :class="item.active ? 'success--text' : 'grey--text'"
                >
                  {{ item.active ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </div>
          </v-card>
          <div class="text-center">
            <v-progress-circular
              v-if="lazyLoader"
              size="25"
              :width="1"
              color="#CCC"
              indeterminate
            />
          </div>
          <div
            ref="observer"
            class="observer"
          />
        </div>
        <div
          v-else
          class="empty-alert-div"
        >
          <v-card
            color="#FFF"
            elevation="0"
          >
            <br><br>
            <p class="empty-alert-msg">
              <v-icon
                size="25"
                color="#C62828"
              >
                mdi-information-outline
              </v-icon>No App users found
            </p>
            <br><br>
          </v-card>
        </div>
      </div>
      <div v-else>
        <div class="empty-alert-div">
          <v-card
            color="#FFF"
            elevation="0"
          >
            <br><br><br>
            <p class="empty-alert-msg">
              <v-icon
                size="25"
                color="#C62828"
              >
                mdi-information-outline
              </v-icon>You don't have permission to view this resource
            </p>
            <br><br>
          </v-card>
        </div>
      </div>
    </div>
    <div
      v-else
      class="empty-alert-div mt-5"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br><br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>No Organizations found
        </p>
        <br><br>
      </v-card>
    </div>
    <centre-spinner :loading="loading" />
    <app-user-details
      v-if="showAppUserDetails"
      :org-external-id="orgExternalId"
      :appuser-id="appuserId"
      @closed="showAppUserDetails = false"
    />
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import AppUserDetails from './AppUserDetails.vue';

export default {
  name: 'AcceptedAppUsersList',
  components: {
    'centre-spinner': spinner,
    'app-user-details': AppUserDetails,
  },
  data: () => ({
    loading: false,
    lazyLoader: false,
    observerFetching: false,
    startPage: 0,
    showAppUserDetails: false,
    orgExternalId: null,
    searchQuery: '',
    selectedCompany: null,
    appuserId: null,
    appUserRole: '',
    currentOrg: null,
    workerCheck: true,
    companyVisibility: false,
    observer: null,
    showSearch: false,
  }),
  computed: {
    acceptedAppUsersList () {
      return this.$store.getters['appusers/getAcceptedAppUsersList'];
    },
    anyAppUsersListAvailable () {
      return this.anyUserOrganizationsAvailable && this.acceptedAppUsersList.length > 0;
    },
    appUserOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    appUserCompanies () {
      return this.$store.getters['company/getAppUsersCompanies'];
    },
    anyUserOrganizationsAvailable () {
      return this.appUserOrganizations.length > 0;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    this.loading = true;
    await this.$store.dispatch('appusers/clearAcceptedAppUsersList');
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    async loadOnMount () {
      this.loading = true;
      await this.getUserOrganizations();
      this.loading = false;
    },
    async getAppUserCompanies () {
      this.loading = true;
      await this.$store.dispatch('company/fetchAppUsersCompanies', {
        organizationId: this.selectedOrganization.organization.external_id,
      });
      this.loading = false;
    },
    async getUserOrganizations () {
      this.loading = true;
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: { requestStatus: 'accepted' },
      });

      if (this.anyUserOrganizationsAvailable) {
        this.currentOrg = this.appUserOrganizations.filter(
          (item) => item.organization.external_id === this.selectedOrganization.organization.external_id,
        );
        this.appUserRole = this.currentOrg[0].app_user_role;
        if (this.appUserRole === 'site-manager') {
          this.workerCheck = false;
          this.companyVisibility = true;
          await this.getAppUserCompanies();
          await this.getAppUsersList();
          await this.initObserver();
        } else if (this.appUserRole === 'contractor') {
          this.workerCheck = false;
          this.companyVisibility = false;
          this.selectedCompany = this.currentOrg[0].company.id;
          await this.getAppUsersList();
          await this.initObserver();
        } else if (this.appUserRole === 'worker') {
          this.workerCheck = true;
        }

        this.$emit(
          'app-user-role',
          this.appUserRole,
          this.selectedOrganization.organization.external_id,
          this.selectedCompany,
        );
      }
      this.loading = false;
    },
    async changeCompany (companyId) {
      this.loading = true;
      this.startPage = 0;
      this.selectedCompany = companyId;
      this.searchQuery = '';
      await this.$store.dispatch('appusers/clearAcceptedAppUsersList');
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
    async searchAppUser () {
      this.startPage = 0;
      this.loading = true;
      await this.$store.dispatch('appusers/clearAcceptedAppUsersList');
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
    async clearAllFilters () {
      this.startPage = 0;
      this.searchQuery = '';
      this.selectedCompany = null;
      this.loading = true;
      await this.$store.dispatch('appusers/clearAcceptedAppUsersList');
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
    async getAppUsersList () {
      if (this.lazyLoader) return;
      this.lazyLoader = true;
      await this.$store.dispatch('appusers/fetchAcceptedAppUsersList', {
        orgExternalId: this.selectedOrganization.organization.external_id,
        params: {
          params: {
            requestStatus: ['accepted', 'invited'],
            startPage: this.startPage,
            limit: 5,
            companyId: this.selectedCompany,
            name: this.searchQuery || null,
          },
        },
      });
      const fetchedLength = this.$store.getters['appusers/getAcceptedAppUsersList'].length;
      if (fetchedLength <= this.startPage) {
        if (this.observer) this.observer.disconnect();
      } else {
        this.startPage += 5;
      }
      this.lazyLoader = false;
    },
    initObserver () {
      if (this.observer) this.observer.disconnect();
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      if (this.$refs.observer) this.observer.observe(this.$refs.observer);
    },
    handleIntersect (entries) {
      if (entries[0].isIntersecting && !this.observerFetching) {
        this.observerFetching = true;
        this.getAppUsersList().finally(() => {
          this.observerFetching = false;
        });
      }
    },
    async toggleUserStatus (user) {
      await this.$store.dispatch('appusers/updateUserStatus', {
        id: user.app_user_organization_id,
        status: {
        active: user.active,
        },
      });
  },
    openAppUserDetails (data) {
      this.appuserId = data.external_id;
      this.orgExternalId = this.selectedOrganization.organization.external_id;
      this.showAppUserDetails = true;
    },
  },
};
</script>
<style scoped>
.approved-app-user-listing {
  position: relative;
  margin-top: 40px;
}
.container {
  border-radius: 10px !important;
  padding: 0px !important;
}
p {
  margin-bottom: 5px;
}
.details-container {
  width: 100% !important;
  border-radius: 10px;
  background: #fff;
}
.btn-position {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.theme--dark.v-list {
  background-color: white !important;
}
.theme--dark >>> .v-list-item {
  color: #37474f !important;
}
.observer {
  height: 40px;
}
.col-5 {
  padding: 12px;
  padding-right: 0;
}
.col-10 {
  padding: 12px;
  padding-right: 0px;
}
.v-btn--fab.v-size--x-small {
  height: 24px !important;
  width: 24px !important;
}
/* Card Improvements */
.user-card {

  border-left: 5px solid transparent;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.user-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

/* Status Indicators */
.active-border {
  border-left-color: #4CAF50 !important;
}

.inactive-border {
  border-left-color: #9E9E9E !important;
}

.bg-light {
  background-color: #fcfcfc;
}

/* Clean up Typography */
.text-overline {
  letter-spacing: 1px !important;
  font-size: 0.7rem !important;
}

/* Search Bar customization */
.search-bar >>> .v-input__control {
  background: white !important;
  border-radius: 8px;
}
</style>
